import { ecsApi } from '@services';
import { LibraryPayload, LibraryResponse } from './library.types';

export const libraryApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getLibrary: builder.mutation<LibraryResponse, LibraryPayload>({
            query: ({ type }) => ({
                url: `/library?category=${type}`,
                method: 'GET'
            })
        })
    })
});

export const { useGetLibraryMutation } = libraryApi;
